var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDriverPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4213_64912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7869 0.200195C17.0394 0.200195 11.5498 5.68974 11.5498 12.4373C11.5498 19.1848 17.0394 24.6743 23.7869 24.6743C30.5344 24.6743 36.0239 19.1848 36.0239 12.4373C36.0239 5.68974 30.5344 0.200195 23.7869 0.200195Z",
    fill: "#9A9AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1702 32.6686C35.82 29.2669 31.3786 27.3936 26.6643 27.3936H21.2256C16.5113 27.3936 12.0699 29.2669 8.71965 32.6686C5.38582 36.0537 3.5498 40.5219 3.5498 45.2506C3.5498 46.0015 4.15858 46.6103 4.90948 46.6103H42.9804C43.7313 46.6103 44.34 46.0015 44.34 45.2506C44.34 40.5219 42.504 36.0537 39.1702 32.6686Z",
    fill: "#9A9AAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4213_64912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4102,
    height: 46.4102,
    fill: "white",
    transform: "translate(0.75 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDriverPlaceholder);
export default __webpack_public_path__ + "static/media/add-driver-placeholder.bb20f17cb47b76554a075867d33572be.svg";
export { ForwardRef as ReactComponent };